module.exports = __webpack_public_path__ + "img/empty.41f213f6.png";